import { graphql } from '@/gql';
import type { UpdateGroceryPriorityLevelMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateGroceryPriorityLevel = async ({
  orderId,
  priorityLevel,
}: UpdateGroceryPriorityLevelMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation UpdateGroceryPriorityLevel($orderId: String!, $priorityLevel: Float!) {
        updateGroceryPriorityLevel(orderId: $orderId, priorityLevel: $priorityLevel) {
          id
        }
      }
    `),
    variables: {
      orderId,
      priorityLevel,
    },
  });

  return !!response.data?.updateGroceryPriorityLevel;
};
